import React,
{
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
  useCallback,
  memo
} from 'react';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import { flowType } from '@utility/userInfo';
import { ReactComponent as ExpandMore } from '@assets/images/expand_more.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { safeJsonParse } from '../../../../utility/helperFunction';

const defaultCustomStyles = (
  name,
  ShowLandscapeMode,
  QRLink,
  transferPopUp,
  swipedDown,
  isLandScape,
  screenType,
  isMenuOpen,
  isFocused,
  isCounter,
  serverAppTheme,
  editCallCenter,
  currentFlowType,
  isDriveThru,
  orderingPortraitOrientation
) => {
  const isServerApp = currentFlowType === "serverApp";
  const isFireboard = currentFlowType === "fireboard";
  const isKiosk = currentFlowType === "kiosk";
  const isPaymentTerminal = currentFlowType === "paymentTerminal";
  const isTableTop = currentFlowType === "tableTop";

  // Cache theme values to prevent redundant lookups
  const themeCheckDetailTabs = serverAppTheme?.checkDetail_tabs;
  const themeInputBg = serverAppTheme?.inputBg || "#393F44";
  const themePrimaryText = serverAppTheme?.primary_text || "#FFFFFF";
  const themeOrderSelectorBorder = serverAppTheme?.order_selector_border;
  const themeStageTabButtonSelected = serverAppTheme?.stage_tab_button_selected;
  const themeInputPlaceholder = serverAppTheme?.input_placeholder;
  const loyaltyBalance = window.location.pathname.includes("/loyalty-balance");
  return {
    container: (provided, state) => ({
      ...provided,
      height:
        name === "menuCategory"
          ? isLandScape
            ? "8vh"
            : isServerApp && screenType === "orders"
              ? "32px"
              : "4vh"
          : "",
      border: name === "menuCategory" && state.isFocused ? "none" : "",
      position:
        name === "menuCategory" && !isLandScape && isFocused && "absolute",
      width: name === "menuCategory" && !isLandScape && state.isFocused && "25vw",
      zIndex:
        name === "menuCategory" && !isLandScape && state.isFocused && "1000",
    }),
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      height:
        isTableTop ||
          isKiosk ||
          isServerApp ||
          isPaymentTerminal ||
          isFireboard
          ? "100%"
          : isCounter || isDriveThru
            ? "100%"
            : "15vh",
      width: isFireboard
        ? "100%"
        : isPaymentTerminal
          ? "16vh"
          : isServerApp &&
            (screenType === "callCenterLogin" || screenType === "callCenter")
            ? "100%"
            : (isServerApp && !ShowLandscapeMode && transferPopUp) || QRLink
              ? ""
              : screenType === "loyalty"
                ? isLandScape
                  ? "27vh"
                  : "15vh"
                : isLandScape
                  ? name === "menuCategory"
                    ? "100%"
                    : screenType === "textReceipt" ||
                      screenType === "offPremise"
                      ? "17vw"
                      : (isCounter || isDriveThru) &&
                        screenType === "PayTextReceipt"
                        ? "40vh"
                        : screenType === "survey" && isLandScape
                          ? "24vh"
                          : screenType === "22" ? "27vh" : '17vh'
                  : screenType === "orderLoyalty"
                    ? "27vh"
                    : name === "menuCategory"
                      ? "100%"
                      : isCounter || isDriveThru
                        ? "13vw"
                        : !isLandScape
                          ? screenType === "PayTextReceipt"
                            ? "10rem"
                            : screenType === "offPremise"
                              ? "15vh"
                              : screenType === "survey"
                                ? "17vh"
                                : "16vh"
                          : "15vh",
      fontSize:
        isServerApp &&
          (screenType === "callCenterLogin" || screenType === "callCenter")
          ? "1rem"
          : "4vw",
      zIndex: QRLink && 1,
      backgroundColor:
        name === "menuCategory"
          ? themeCheckDetailTabs
          : "transparent",
      border:
        name === "menuCategory" && state.isFocused
          ? themeOrderSelectorBorder
          : "none",
      borderTopLeftRadius: name === "menuCategory" ? "4px" : "",
      borderTopRightRadius: name === "menuCategory" ? "4px" : "",
      borderBottomLeftRadius: name === "menuCategory" && !isFocused ? "4px" : "",
      borderBottomRightRadius: name === "menuCategory" && !isFocused ? "4px" : "",
      color: name === "menuCategory" ? "white" : "",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 0px 2px 0px !important",
      fontSize: screenType === "offPremise" ? "3vw" : "4vw",
      height:
        isServerApp
          ? isServerApp && !isLandScape && screenType === "orders"
            ? "32px"
            : "100%"
          : "100%",
      backgroundColor:
        name === "menuCategory" ? themeCheckDetailTabs : "",
      borderTopLeftRadius: name === "menuCategory" ? "4px" : "",
      borderBottomLeftRadius: name === "menuCategory" && !isFocused ? "4px" : "",
      position: screenType === "callCenter" && "relative",
      justifyContent: screenType === "callCenter" ? 'flex-start' : 'center',
      ...((isFireboard || screenType === "orderMenuTop")? { display: "block" } : {})
    }),
    singleValue: (provided, state) => ({
      ...provided,
      maxWidth: "100%",
      textOverflow: "unset",
      fontSize:
        isKiosk || isPaymentTerminal
          ? "3.5vw"
          : isServerApp &&
            (screenType === "callCenterLogin" || screenType === "callCenter")
            ? "1rem"
            : isFireboard ? '1.5vw' :
              name === "menuCategory"
                ? isLandScape
                  ? "1.6vw"
                  : isFocused
                    ? "3.5vw"
                    : "3vw"
                : screenType === "loyalty"
                  ? isLandScape ? "1.3rem" : "4.1vw"
                  : screenType === "orderLoyalty"
                    ? "1.3rem"
                    : (isCounter || isDriveThru)
                      ? "1rem"
                      : screenType === "PayTextReceipt"
                        ? "4.3vw"
                        : screenType === "SendQRLink"
                          ? "2rem"
                          : screenType === "offPremise"
                            ? "26px"
                            : screenType === "survey"
                              ? (isLandScape ? "20px" : "4.6vw")
                              : screenType === "orderMenuTop"
                                ? "14px"
                                : "1.5rem",
      color: themePrimaryText,
      marginLeft: isLandScape && screenType === "survey" || screenType === "orderMenuTop" ? "6px" : (screenType !== "callCenter" && screenType !== "callCenterLogin"  ? "16px" : '' ),
      marginTop: name === "menuCategory" && "-16px",
      marginBottom: isLandScape && screenType === "survey" ? "15px" : ((isCounter || isDriveThru) ? "8px" : loyaltyBalance ? '12px' : ''),
      position: isFireboard ? 'absolute' :
        (screenType === "callCenterLogin" || screenType === "callCenter") &&
        "relative",
      top:
        (screenType === "callCenterLogin" || screenType === "callCenter") && !orderingPortraitOrientation && "-6px",
      left: screenType === "callCenter" && (orderingPortraitOrientation && name === "job") ? '120px' : (orderingPortraitOrientation && name === "phoneNumOffPremise") ? '0px' : (!orderingPortraitOrientation && name === "phoneNumOffPremise") ? "0" : "152px",
      height: isFireboard && '100%',
      display: isFireboard && 'flex',
      alignItems: isFireboard && 'center',
      justifyContent: isFireboard && 'center',
      marginRight : screenType === "callCenter" && screenType === "callCenterLogin" && '0' 
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: isKiosk ? "none" : "flex",
      height:
        isServerApp && !isLandScape && screenType === "orders"
          ? "32px"
          : "",
      padding: "0px",
      paddingBottom: screenType === "orderMenuTop" && "12px",
      backgroundColor:
        name === "menuCategory" ? themeCheckDetailTabs : "",
      borderTopRightRadius: name === "menuCategory" ? "4px" : "",
      borderBottomRightRadius: name === "menuCategory" && !isFocused ? "4px" : "",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      fontWeight: 400,
      fontSize:
        isFireboard ? '1.4vw'
          : screenType === "orderMenuTop"
            ? "12px"
            : isKiosk || isPaymentTerminal
              ? "3vw"
              : isLandScape
                ? name === "menuCategory"
                  ? "1.6vw"
                  : (isCounter || isDriveThru)
                    ? "32px"
                    : screenType === "PayTextReceipt"
                      ? "16px"
                      : "20px"
                : screenType === "orderLoyalty"
                  ? "1.3rem"
                  : name === "menuCategory"
                    ? "3.5vw"
                    : (isCounter || isDriveThru)
                      ? "1rem"
                      : screenType === "PayTextReceipt"
                        ? "4.3vw"
                        : isServerApp &&
                          (screenType === "callCenterLogin" ||
                            screenType === "callCenter")
                          ? "1rem"
                          : screenType === "survey"
                            ? "4.6vw"
                            : "3vw",
      textAlign: "left",
      color: state.isSelected && (name === "phoneNumOffPremise" || name === "job" || screenType === "callCenter")
        ? "#fff"
        : themePrimaryText,
      backgroundColor:
        name === "menuCategory" && state.isSelected
          ? themeCheckDetailTabs
          : name === "phoneNumOffPremise" && state.isSelected
            ? serverAppTheme?.dropdownSelectedPhone
            : (screenType === "callCenterLogin" || screenType === "callCenter") && state.isSelected
              ? serverAppTheme?.dropdownSelectedPhone
              : "",
    }),
    menu: (provided) => ({
      ...provided,
      position:
        QRLink && swipedDown
          ? "fixed"
          : name === "menuCategory" && isLandScape && "relative",
      marginTop: QRLink && swipedDown ? "-400px" : "",
      top: name === "menuCategory" && "0",
      width:
        isFireboard ? "100%"
        : screenType === "loyalty" ? "100%"
          : screenType === "orderMenuTop"
            ? "19vh"
            : isPaymentTerminal
              ? "16vh"
              : isServerApp &&
                (screenType === "callCenterLogin" || screenType === "callCenter")
                ? orderingPortraitOrientation && name!== "job" ? '15vh' :  "100%"
                : (isServerApp && ShowLandscapeMode) || QRLink
                  ? "20vw"
                  : (isCounter || isDriveThru)
                    ? "15vw" : (isLandScape && screenType === "survey") ? "26vh"
                    : isLandScape
                      ? name === "menuCategory"
                        ? "100%"
                        : screenType === "textReceipt" ||
                          screenType === "offPremise"
                          ? "21vw"
                          : screenType === "22" ? '26vh' : "21vh"
                      : name === "menuCategory"
                        ? "100%"
                        : screenType === "PayTextReceipt"
                          ? "10rem"
                          : screenType === "survey"
                            ? "19vh"
                            : screenType === "orderLoyalty"
                              ? "100%"
                              : "15vh",
      zIndex: QRLink ? 9999 : name === "menuCategory" ? "10000000" : "",
      background:
        name === "menuCategory"
          ? themeStageTabButtonSelected
          : `var(--input-field-fill, ${themeInputBg})`,
      border:
        name === "menuCategory" ? themeOrderSelectorBorder : "",
      borderBottomLeftRadius: name === "menuCategory" ? "4px" : "",
      borderBottomRightRadius: name === "menuCategory" ? "4px" : "",
      fontSize:
        screenType === "orderMenuTop"
          ? "12px"
          : screenType === "orderLoyalty"
            ? "1.3rem"
            : isServerApp &&
              (screenType === "callCenterLogin" || screenType === "callCenter")
              ? "1rem"
              : "inherit",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      marginLeft: "0",
      position: screenType === "callCenter" && "relative",
      fontSize: screenType === "callCenter" ? "1rem" : "",
      color: themeInputPlaceholder,
      top: screenType === "callCenter" && !orderingPortraitOrientation && "-6px",
      left: screenType === "callCenter" && orderingPortraitOrientation ? '115px' : "144px"
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding:
        name === "menuCategory" || screenType === "callCenter" ? "0px" : "8px",
      color: themePrimaryText,
      width: name === "menuCategory" && !state.isFocused && !isLandScape && "3vw",
      transition: "transform 0.2s",
      transform: screenType === "orders" && isMenuOpen ? "rotate(180deg)" : null,
      display: screenType === "orderMenuTop" ? "none" : "contents",
      svg: {
        width: isFireboard ? '1.5vw' : '30px',
        height: isFireboard ? '1.5vw' : '30px',
      },
    }),
    Svg: (provided) => ({
      ...provided,
      border: "1px solid white",
      width: isFireboard && '30px',
      hight: isFireboard && '30px',
    }),
    menuPortal: (base, state) => {
  const rect = state.selectProps?.selectRef?.current?.getBoundingClientRect();

  return {
    ...base,
    zIndex: 999999,
    left: orderingPortraitOrientation
      ? '15px'            
      : rect?.left || base.left,
  };
}
  };
};
const SimpleReactSelect = memo(forwardRef((props, ref) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const selectRef = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => {
        return selectRef.current.state.value;
      }
    }),
    []
  );
  const {
    name,
    id,
    options,
    placeholder,
    isMulti,
    isDisabled,
    isClearable,
    maxMenuHeight,
    className,
    onChange,
    customLabel,
    onSelect = () => {},
    onBlur = () => {},
    customId,
    defaultValue,
    ShowLandscapeMode,
    transferPopUp,
    QRLink,
    swipedDown,
    isLandScape,
    screenType,
    isFocused,
    isCounter,
    serverAppTheme,
    editCallCenter,
    isDriveThru,
    orderingPortraitOrientation,
  } = props;
  const deviceInfo = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {});
  const memoizedCustomComponents = useMemo(() => {
    if (screenType === 'callCenter') {
      return {
        DropdownIndicator: (dropdownProps) => (
          <components.DropdownIndicator {...dropdownProps}>
            <ExpandMore fill={serverAppTheme?.iconcolor} />
          </components.DropdownIndicator>
        ),
        ClearIndicator: (clearProps) => (
          <components.ClearIndicator {...clearProps}>
            <Cross fill={serverAppTheme?.iconcolor} />
          </components.ClearIndicator>
        ),
      };
    }

    if (flowType() === 'serverApp' && screenType === 'orders' && name === 'menuCategory') {
      return {
        Control: (controlProps) => {
          const { children, menuIsOpen, innerProps, selectProps } = controlProps;
          return (
            <components.Control
              {...controlProps}
              innerProps={{
                ...innerProps,
                onMouseDown: (e) => {
                  e.preventDefault();
                  if (menuIsOpen) {
                    selectProps.onMenuClose();
                  } else {
                    selectProps.onMenuOpen();
                  }
                },
              }}
            >
              {children}
            </components.Control>
          );
        },
      };
    }

    return {};
  }, [serverAppTheme?.iconcolor, screenType, name]);

  const flowTypeValue = useMemo(() => flowType(), []);

  const styles = useMemo(() =>
    defaultCustomStyles(name, ShowLandscapeMode, QRLink, transferPopUp, swipedDown, isLandScape, screenType, isMenuOpen, isFocused, isCounter, serverAppTheme, editCallCenter, flowTypeValue, isDriveThru, orderingPortraitOrientation),
    [name, ShowLandscapeMode, QRLink, transferPopUp, swipedDown, isLandScape, screenType, isMenuOpen, isFocused, isCounter, serverAppTheme, editCallCenter, flowTypeValue, isDriveThru, orderingPortraitOrientation]
  );

  const selectedValue = useMemo(() => options.find(item => item.id === defaultValue), [options, defaultValue]);

  const getOptionLabelCallback = useCallback((option) => {
    return customLabel ? option[customLabel] : option.name
  }, [customLabel]);

  const getOptionValueCallback = useCallback((option) => {
    return customId ? option[customId] : option.id;
  }, [customId]);

  const onChangeCallback = useCallback((data) => { if (onChange) onChange(data); }, [onChange]);
  const onFocusCallback = useCallback(() => onSelect(), [onSelect]);
  const onBlurCallback = useCallback(() => onBlur(), [onBlur]);
  const onMenuOpenCallback = useCallback(() => screenType !== 'callCenter' && setIsMenuOpen(true), [screenType]);
  const onMenuCloseCallback = useCallback(() => screenType !== 'callCenter' && setIsMenuOpen(false), [screenType]);

  return (
    <Select
      name={name}
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={placeholder}
      className={className}
      isMulti={isMulti}
      maxMenuHeight={maxMenuHeight}
      isClearable={isClearable}
      options={options}
      id={id}
      ref={selectRef}
      blurInputOnSelect
      getOptionLabel={getOptionLabelCallback}
      getOptionValue={getOptionValueCallback}
      onChange={onChangeCallback}
      value={selectedValue}
      styles={styles}
      onFocus={onFocusCallback}
      onBlur={onBlurCallback}
      onMenuOpen={onMenuOpenCallback}
      onMenuClose={onMenuCloseCallback}
      theme={(theme) => ({
        ...theme,
        borderRadius: '',
        borderWidth: '2px',
        borderBottom: serverAppTheme?.inputBorder_Bottom,
        border:'none',
        colors: {
          ...theme.colors,
          primary: screenType !== 'orderMenuTop' && (serverAppTheme? serverAppTheme?.inputBorder_Bottom : 'rgba(173, 0, 40, 0.40)'),
        },
      })}
      menuPortalTarget={screenType === "orders" ? null : document.body}
      components={memoizedCustomComponents}
    />
  );
}));


const mapStateToProp = ({orders}) => ({
  orderingPortraitOrientation: orders?.orderingPortraitOrientation
})
export default connect(mapStateToProp)(SimpleReactSelect);
